// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__7JmpR","spinner":"Search_spinner__Mxj_m"};